import { RED_XL_GROUP, SALESCHANNEL_YOUNG } from '@vfde-fe/sails-constants';

/**
 * getIsRestlaufzeitEligible
 * Restlaufzeit is eligible when:
 * isGigakombi true, salesChannel is not young and activeSubscriptionId is not RED_XL_GROUP
 * TODO: check why isGigakombi is relevant for restlaufzeit
 */
export const getIsRestlaufzeitEligible = (isGigakombi: boolean, salesChannel: string, activeSubscriptionId: string | null): boolean => {
    if (!isGigakombi || !activeSubscriptionId) {
        return false;
    }

    return salesChannel !== SALESCHANNEL_YOUNG && activeSubscriptionId !== RED_XL_GROUP.toString();
};
